import { CommentForm, CommentsList } from "@app/shared/components/Comments";
import { useCommentsPanel } from "@app/shared/hooks";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import { Loader2, LogInIcon, MessageCircleIcon, RefreshCw } from "lucide-react";

type CommentsProps = {
  className?: string;
  type: string;
  typeId: number;
};

export function Comments({ className, typeId, type }: CommentsProps) {
  const { commentsCount, commentsState, isEditing, isLoggedIn, loadComments } =
    useCommentsPanel(typeId, type);

  const { state } = commentsState;

  return (
    <div
      className={`rounded-3xl border border-slate-200/80 bg-white/80 p-4 shadow-sm backdrop-blur-sm dark:border-slate-800 dark:bg-slate-950/70 sm:p-6 ${className || ""}`}
    >
      {isLoggedIn && !isEditing ? (
        <CommentForm typeId={typeId} type={type} />
      ) : !isLoggedIn ? (
        <Link
          to={URLS.auth.login}
          className="flex items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-4 text-center text-sm font-bold text-slate-600 transition hover:border-primary hover:text-primary dark:border-slate-700 dark:bg-slate-800/50 dark:text-slate-300"
        >
          <LogInIcon className="h-5 w-5" />
          <span>{trans("loginToComment")}</span>
        </Link>
      ) : null}
      <div className="mt-6 border-t border-slate-200 pt-5 dark:border-slate-800">
        <div className="mb-5 flex items-center gap-2">
          <MessageCircleIcon className="h-5 w-5 text-primary" />
          <h3 className="font-black text-slate-800 dark:text-white">
            {trans("comments")} ({commentsCount})
          </h3>
        </div>
        {state === "loading" || state === "idle" ? (
          <div className="flex items-center justify-center gap-2 py-7 text-sm text-slate-500 dark:text-slate-400">
            <Loader2 className="h-4 w-4 animate-spin" />
            {trans("loadingComments")}
          </div>
        ) : state === "error" ? (
          <button
            type="button"
            onClick={loadComments}
            className="mx-auto flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-bold text-slate-600 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200"
          >
            <RefreshCw className="h-4 w-4" />
            {trans("retryLoadingComments")}
          </button>
        ) : (
          <CommentsList typeId={typeId} type={type} />
        )}
      </div>
    </div>
  );
}
